/**
 * Quick-add data for linked products (colour groups) on product cards, loaded on demand.
 *
 * snippets/product_card_atc.liquid prints every variant of the card's own product but only one
 * variant (first available) of each other colour in the group, and sets
 * productData.linkedVariantsUrl. That is enough to draw the colour swatches on the card.
 * The first time a shopper shows interest in a card (pointer over it, touch, keyboard focus or a
 * click such as the quick-add button), this loads the full group from
 * templates/product.quickadd-json.liquid and rebuilds the card's option selectors from it.
 *
 * Cards also key their linked-product badges by product handle
 * (snippets/linked_products_badges.liquid, byHandle: true), so this shows the right badge after
 * each variant change.
 *
 * Loaded by snippets/product_main_js_inc.liquid after product_main.js.
 */
(function () {
  if (window.PilotiLinkedVariants) return;

  function loadLinkedVariants(card) {
    var data = card && card.productData;
    var url = data && data.linkedVariantsUrl;
    if (!url) return Promise.resolve();
    if (card.linkedVariantsPromise) return card.linkedVariantsPromise;

    card.linkedVariantsPromise = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('quickadd-json ' + response.status);
        return response.json();
      })
      .then(function (full) {
        if (!full || !Array.isArray(full.variants) || full.variants.length <= data.variants.length) return;
        data.variants = full.variants;
        if (data.groupDetails && full.groups) {
          data.groupDetails.groups = Object.assign({}, full.groups, data.groupDetails.groups);
        }
        data.linkedVariantsUrl = null;
        card.optionValues = {};
        // Rebuild every option selector on the card (the quick-add form and the colour swatches
        // shown on the card), keeping the current selection. Rebuilding replaces the swatch
        // markup, which drops the colour swatch images, so then re-run variantChange to paint
        // them again (the same call <product-variants> makes when it first loads).
        card.querySelectorAll('product-variants').forEach(function (variantsElement) {
          if (typeof variantsElement.refreshOptions !== 'function' || !variantsElement.variantInput) return;
          var currentVariant = variantsElement.getCurrentVariant();
          if (!currentVariant) return;
          variantsElement.refreshOptions(-1, currentVariant);
          variantsElement.variantChange(currentVariant, false);
        });
      })
      .catch(function (error) {
        // Keep working with the partial data; try again on the next interaction.
        card.linkedVariantsPromise = null;
        console.warn(error);
      });
    return card.linkedVariantsPromise;
  }

  function onInterest(event) {
    var target = event.target;
    var card = target && target.closest ? target.closest('product-card-atc') : null;
    if (card) loadLinkedVariants(card);
  }

  ['pointerover', 'touchstart', 'focusin', 'click'].forEach(function (type) {
    document.addEventListener(type, onInterest, { capture: true, passive: true });
  });

  // variantChange doesn't bubble, but it does pass through document in the capture phase.
  document.addEventListener('variantChange', function (event) {
    var card = event.target;
    if (!card || card.tagName !== 'PRODUCT-CARD-ATC') return;
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    // Run after the card's own handler, which clears the badge when no variant class matches.
    setTimeout(function () {
      var badgesWrap = card.querySelector('.linked-product-badges');
      var cardBadges = card.querySelector('.product-badges');
      if (!badgesWrap || !cardBadges || !badgesWrap.querySelector('[data-handle]')) return;
      var groups = card.productData && card.productData.groupDetails && card.productData.groupDetails.groups;
      var url = (groups && groups[variant.id] && groups[variant.id].url) || '';
      var handle = url.split('?')[0].split('/').pop();
      var badge = handle ? badgesWrap.querySelector('.linked-product-badge[data-handle="' + CSS.escape(handle) + '"] .badge') : null;
      cardBadges.innerHTML = badge ? badge.outerHTML : '';
    }, 0);
  }, true);

  window.PilotiLinkedVariants = { load: loadLinkedVariants };
})();
